import { ProviderActivationStatus, CurrentUser } from '@uplift/api';
import { useProviderActivationQuery } from '@uplift/queries';
import { UserStatus } from '@uplift/types';

export const useIsCurrentProviderLive = (me: CurrentUser) => {
  const { data: providerActivation } = useProviderActivationQuery(me.id);

  return (me.status === UserStatus.regular && providerActivation?.status === undefined) || providerActivation?.status === ProviderActivationStatus.live;
};
